import { Typography, Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

import THEME from '../../../constants/theme';

/**
 * GoBackButton - Reusable component for navigation back to previous pages
 *
 * @param {Object} props - Component props
 * @param {string} props.backTo - Route to navigate to when clicked
 * @param {string} props.backText - Text to display on button
 * @param {Object} props.sx - Additional MUI styling
 * @returns {React.Component} GoBackButton component
 */
const GoBackButton = ({ backTo, backText, sx = {} }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(backTo);
  };

  return (
    <Box
      sx={{
        my: 3,
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        width: 'fit-content',
        '&:hover': {
          '& .MuiSvgIcon-root, & .MuiTypography-root': {
            color: THEME.COLORS.PRIMARY_BLUE
          }
        },
        ...sx
      }}
      onClick={handleGoBack}
    >
      <ArrowBackIcon
        sx={{
          fontSize: '2rem',
          transition: `color ${THEME.TRANSITIONS.FAST}`
        }}
      />
      <Typography
        variant='h5'
        component='span'
        sx={{
          fontFamily: THEME.TYPOGRAPHY.FONT_FAMILY.PRIMARY,
          fontWeight: THEME.TYPOGRAPHY.FONT_WEIGHT.MEDIUM,
          ml: '8px',
          transition: `color ${THEME.TRANSITIONS.FAST}`,
          fontSize: '1.3rem'
        }}
      >
        {backText || 'Back'}
      </Typography>
    </Box>
  );
};

export default GoBackButton;
